import { Timestamp, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { CardBlockImage, ModuleDataToUpdate } from "../types";
import { saveContentBlocksImages } from "./saveContentBlocksImages";
import { saveTopPrivacyTipsBlockImage } from "./saveTopPrivacyTipsBlockImage";

export const updateModuleTemplate = async (
  moduleId: string,
  moduleData: ModuleDataToUpdate,
  threeCardBlockImages: CardBlockImage[],
  topPrivacyTipsBlockImage: CardBlockImage,
): Promise<void> => {
  const collectionRef = collection(db, "moduleTemplates");
  await updateDoc(doc(collectionRef, moduleId), {
    ...moduleData,
    updatedAt: Timestamp.now(),
  });

  if (threeCardBlockImages.some((item) => item instanceof File)) {
    await saveContentBlocksImages({
      moduleId,
      threeCardBlockImages,
    });
  }

  if (topPrivacyTipsBlockImage instanceof File) {
    await saveTopPrivacyTipsBlockImage({ moduleId, topPrivacyTipsBlockImage });
  }
};
